import { useRef } from 'react';
import { useToggle } from '@/hooks/useToggle';
import IconButton from '@/components/IconButton';
import { AddIcon, EditIcon } from '@/icons';
import Menu, { MenuItem } from '@/components/Menu';

export type TimelineMenuProps = {
  onAddNote: () => void;
};

export default function TimelineMenu({ onAddNote }: TimelineMenuProps) {
  const menuToggleRef = useRef(null);
  const [isMenuOpen, toggleMenu] = useToggle();

  const handleNewNote = () => {
    onAddNote();
    toggleMenu(false);
  };

  return (
    <>
      <IconButton ref={menuToggleRef} onClick={() => toggleMenu()}>
        <AddIcon />
      </IconButton>
      {isMenuOpen && (
        <Menu
          anchorTo={menuToggleRef.current}
          open
          onClose={() => toggleMenu(false)}>
          <MenuItem
            label="Add Note"
            icon={<EditIcon />}
            onClick={handleNewNote}
          />
        </Menu>
      )}
    </>
  );
}
